import { Handle, Position } from '@xyflow/react';

interface ConditionNodeData extends Record<string, unknown> {
  label: string;
  type: 'condition';
  condition: string;
  trueLabel?: string;
  falseLabel?: string;
}

interface ConditionNodeProps {
  data: ConditionNodeData;
  selected?: boolean;
}

export default function ConditionNode({ data, selected }: ConditionNodeProps) {
  return (
    <div
      style={{
        position: 'relative',
        width: '140px',
        height: '140px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Diamond shape */}
      <div
        style={{
          width: '100px',
          height: '100px',
          background: 'linear-gradient(135deg, #eab308 0%, #ca8a04 100%)',
          border: selected ? '3px solid #a16207' : '2px solid #eab308',
          transform: 'rotate(45deg)',
          borderRadius: '8px',
          boxShadow: selected
            ? '0 0 0 4px rgba(234, 179, 8, 0.3), 0 4px 12px rgba(0, 0, 0, 0.15)'
            : '0 4px 12px rgba(0, 0, 0, 0.15)',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
        }}
      />
      
      {/* Content */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          color: 'white',
          zIndex: 1,
          width: '120px',
          pointerEvents: 'none',
        }}
      >
        <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '4px' }}>
          {data.label}
        </div>
        {data.condition && (
          <div
            style={{
              fontSize: '10px',
              opacity: 0.9,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              background: 'rgba(255,255,255,0.15)',
              padding: '2px 6px',
              borderRadius: '4px',
              maxWidth: '100px',
              margin: '0 auto',
            }}
          >
            {data.condition}
          </div>
        )}
      </div>
      
      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Top}
        style={{
          width: '12px',
          height: '12px',
          background: '#eab308',
          border: '2px solid white',
          top: '10px',
        }}
      />
      
      {/* True output handle */}
      <Handle
        type="source"
        position={Position.Bottom}
        id="true"
        style={{
          width: '12px',
          height: '12px',
          background: '#22c55e',
          border: '2px solid white',
          bottom: '10px',
        }}
      />
      
      {/* False output handle */}
      <Handle
        type="source"
        position={Position.Right}
        id="false"
        style={{
          width: '12px',
          height: '12px',
          background: '#ef4444',
          border: '2px solid white',
          right: '10px',
        }}
      />
      
      {/* Labels for outputs */}
      <div
        style={{
          position: 'absolute',
          bottom: '2px',
          left: '50%',
          transform: 'translateX(-50%)',
          fontSize: '9px',
          color: '#22c55e',
          fontWeight: 'bold',
          background: 'white',
          padding: '1px 4px',
          borderRadius: '2px',
          pointerEvents: 'none',
        }}
      >
        {data.trueLabel || '是'}
      </div>
      
      <div
        style={{
          position: 'absolute',
          right: '2px',
          top: '50%',
          transform: 'translateY(-50%)',
          fontSize: '9px',
          color: '#ef4444',
          fontWeight: 'bold',
          background: 'white',
          padding: '1px 4px',
          borderRadius: '2px',
          pointerEvents: 'none',
        }}
      >
        {data.falseLabel || '否'}
      </div>
    </div>
  );
}
